import * as React from 'react'
import * as st from './title.module.scss'
import { MakeUrl } from '../../selectors/requestContext'
import { detailPagePath } from '../../utils/url'
import { AtfTreatmentProps } from '../../reducers/features'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'

export interface ITitleProps extends AtfTreatmentProps {
  title?: string
  asin?: string
  cGti?: string
  showLinkToDP?: boolean
  makeUrl?: MakeUrl
  isRetail?: boolean
  isHover? : boolean
}

export const Title = ({ title, asin, cGti, isRetail, makeUrl, showLinkToDP = false, isHover = false,
                      atfTreatment}: ITitleProps) => {
  const decoratedTitle = title && <h1 className={cn('dv-node-dp-title avu-full-width', isHover ? st.titleHover: st.title, {[st.textShadow]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}
                                      data-automation-id="title">{title}</h1>
  if (!decoratedTitle) {
    return null
  } else if (showLinkToDP) {
    const titleId = isRetail ? asin || cGti : cGti
    const url = makeUrl && titleId && makeUrl(detailPagePath(titleId), {refTag: 'atv_hover_title'})
    return <a href={url}>{decoratedTitle}</a>
  } else {
    return decoratedTitle
  }
}


